import TemplateView from '../../TemplateView'

export default class ListItem extends TemplateView {
    constructor({
        text = '',
        additionalClass = '',
        onClick = () => {},
    }) {
        super()

        this.params = {
            text,
            additionalClass,
            onClick,
        }
    }

    templateHtml() {
        return '<div class="item <%=additionalClass%>"><%-text%></div>'
    }

    templateModel() {
        return {
            text: this.params.text,
            additionalClass: this.params.additionalClass,
        }
    }

    afterRender() {
        this.$el.click(() => this.params.onClick())
    }
}


// WEBPACK FOOTER //
// ./web/js/components/list/ListItem.js